// 统一请求路径前缀在libs/axios.js中修改
import {getRequest, postRequest, getRequestFromGangan, getRequestGangAn, postRequestNobase} from '@/libs/axios';

// 获取省市列表
export const _getProvinceAndCityList = (params) => {
    return getRequest('/config/getProvinceAndCityList', params)
};

//个人认证提交
export const _getpersonRealName = (params) => {
    return postRequest('/realName/personRealName', params)
};

//企业认证第一步
export const _enterpriseRealNameFirst = (params) => {
    return postRequest('/realName/enterpriseRealNameFirst', params)
};

//企业认证第二部
export const _enterpriseRealNameSecond = (params) => {
    return postRequest('/realName/enterpriseRealNameSecond', params)
};

//获取用户实名信息

export const _findMainObligee = (params) => {
    return getRequest('/powerUser/findMainObligee', params)
};


// 重新实名认证信息
export const _updatePowerUserIdentity = (params) => {
    return getRequest('/powerUser/updatePowerUserIdentity', params)
};

//保存联系信息
export const _saveGsfwUser = (params) => {
    return postRequestNobase('/gangan/front/gsfwUser/save', params)
};

//从前海版权公共服务平台1.0获取登记办理点
export const _getBelongRegions = () => {
    return getRequestGangAn('/front/gsfwBelongRegion/getFromGangan', null)
};

export const _findGsfwUser = () => {
    return getRequestGangAn('/front/gsfwUser/getGsfwUser', null)
};


